import { BreakpointsOptions } from "@mui/material/styles";

const MOBILE_BREAKPOINT =
  process && process.env && (process.env.MOBILE_BREAKPOINT as string);

const breakpoints: BreakpointsOptions = {
  values: {
    xs: 0,
    sm: 600,
    md: +MOBILE_BREAKPOINT || 980,
    lg: 1200,
    xl: 1536,
  },
};

export default breakpoints;
